import { createContext, useContext, useState } from "react";

export interface AuthData {
  token?: string;
  agency_user_id?: string;
  agency_id?: string;
  agency_name?: string;
  full_name?: string;
  email?: string;
  phone?: string;
  agency_user_profile_id?: number;
  profile_name?: string;

  orgId?: string;
}

interface AuthContextProps {
  isAuthenticated: boolean;
  auth: AuthData | null;
  login: (data: AuthData) => void;
  logout: () => void;
}

const AuthContext = createContext<AuthContextProps | null>(null);

export const AuthProvider = ({ children }: { children: React.ReactNode }) => {
  const [isAuthenticated, setIsAuthenticated] = useState(
    localStorage.getItem("login") === "true",
  );

  const [auth, setAuth] = useState<AuthData | null>(() => {
    const data = localStorage.getItem("auth");
    return data ? JSON.parse(data) : null;
  });

  function login(data: AuthData) {
    localStorage.setItem("login", "true");
    localStorage.setItem("auth", JSON.stringify(data));

    setAuth(data);
    setIsAuthenticated(true);
  }

  function logout() {
    // window.location.href = "/login";
    localStorage.removeItem("login");
    localStorage.removeItem("auth");

    setAuth(null);
    setIsAuthenticated(false);
  }

  return (
    <AuthContext.Provider
      value={{
        isAuthenticated,
        auth,
        login,
        logout,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => {
  const context = useContext(AuthContext);

  if (!context) {
    throw new Error("useAuth must be inside AuthProvider!");
  }

  return context;
};
